import styled from "styled-components";

import { DESKTOP_BREAKPOINT } from "../../../../../../components/AppShell/styles";

const MOBILE = `not all and (min-width: ${DESKTOP_BREAKPOINT})`;

/* The section tiles, in the Modal's body (lg, with a line under the header). Mobile: 3 compact columns */
export const SectionGrid = styled.div`
  color: var(--color-neutral-white);

  .grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    /* Tiles clip their corners (overflow: hidden), which lets auto rows shrink them to fit
       the modal height; max-content keeps each tile whole and lets the grid scroll instead */
    grid-auto-rows: max-content;
    gap: 1rem;
  }

  .tile {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    text-align: left;
    background: var(--color-neutral-darkness);
    border: 1px solid var(--color-neutral-base);
    border-radius: 12px;
    transition:
      border-color 0.15s,
      transform 0.15s;

    &:hover:not(.inactive) {
      border-color: var(--color-neutral-150);
      transform: translateY(-2px);
    }

    &.inactive {
      cursor: not-allowed;
      opacity: 0.45;
    }
  }

  .preview {
    position: relative;
    display: block;
    aspect-ratio: 16 / 10;
    padding: 0.5rem;
    background: var(--color-neutral-darkness);
    border-bottom: 1px solid var(--color-neutral-base);
  }

  /* PLUS sections: green glow and border, same language as the other PLUS highlights */
  .tile.plus {
    background:
      radial-gradient(120% 120% at 0% 0%, rgba(87, 242, 139, 0.18) 0%, rgba(87, 242, 139, 0) 60%),
      var(--color-neutral-dark);
    border-color: rgba(87, 242, 139, 0.4);

    .preview {
      background: transparent;
      border-bottom-color: rgba(87, 242, 139, 0.2);
    }

    .info {
      background: transparent;
    }

    &:hover:not(.inactive) {
      border-color: var(--color-brand-plus);
    }
  }

  .plus-tag {
    position: absolute;
    top: 0.5rem;
    left: 0.5rem;
  }

  .used {
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
    padding: 0.125rem 0.5rem;
    font-family: Inter, sans-serif;
    font-size: 0.625rem;
    font-weight: 700;
    color: var(--color-neutral-white);
    background: var(--color-neutral-base);
    border-radius: 100px;
  }

  .info {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 0.25rem;
    padding: 0.75rem;
    background: var(--color-neutral-dark);
  }

  .name {
    display: flex;
    gap: 0.5rem;
    align-items: center;
    font-family: Inter, sans-serif;
    font-size: 0.8125rem;
    font-weight: 700;
    line-height: 1rem;
  }

  .description {
    font-family: Inter, sans-serif;
    font-size: 0.75rem;
    line-height: 1rem;
    color: var(--color-neutral-150);
  }

  @media ${MOBILE} {
    .grid {
      grid-template-columns: repeat(3, minmax(0, 1fr));
      gap: 0.5rem;
    }

    .preview {
      padding: 0.25rem;
    }

    .plus-tag {
      top: 0.25rem;
      left: 0.25rem;
      padding: 0 0.375rem;
      font-size: 0.5rem;
    }

    .used {
      top: 0.25rem;
      right: 0.25rem;
      padding: 0.0625rem 0.375rem;
      font-size: 0.5625rem;
    }

    .info {
      padding: 0.5rem;
    }

    .name {
      gap: 0.25rem;
      font-size: 0.6875rem;
      line-height: 0.875rem;
    }

    /* Compact tiles: name only */
    .description {
      display: none;
    }
  }
`;
